import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext';
import { useMobileNav } from '../../contexts/MobileNavContext';

const TodoListRedirect: React.FC = () => {
  const { listId = '' } = useParams<{ listId: string }>();
  const { mobileScheduleHomeEnabled } = useFeatureFlags();
  const { isMobile } = useMobileNav();
  const params = new URLSearchParams({ list: listId });
  if (isMobile && !mobileScheduleHomeEnabled) params.set('tab', 'reminders');
  return <Navigate to={`/?${params.toString()}`} replace />;
};

export default TodoListRedirect;
